import * as echarts from 'echarts'
import { getElColorPrimary } from '@/utils/theme-color'
import { getEchartsFontFamily } from '@/utils/echarts-option/font'
import { getOpacityColor } from '@/utils/tool'

/** 饼图渐变色获取 */
export function getItemGradient (color, opacity = 0.75, path = [0, 0, 1, 1.5]) {
  return new echarts.graphic.LinearGradient(path[0], path[1], path[2], path[3], [{
    offset: 0,
    color: getOpacityColor(color, opacity)
  }, {
    offset: 0.5,
    color: color
  }])
}

export function useLabelHover (chartInstance) {
  const option = chartInstance.getOption()
  const color = option.series[0]?.data[0]?.label?.color

  chartInstance.on('mousemove', 'series', (params) => {
    const option = chartInstance.getOption()
    const item = option.series[0].data.find(v => v.name === params.name)
    item.label.color = getElColorPrimary()
    item.label.fontFamily = getEchartsFontFamily()
    chartInstance.setOption(option)
  })

  chartInstance.on('mouseout', 'series', function (params) {
    const option = chartInstance.getOption()
    const item = option.series[0].data.find(v => v.name === params.name)
    item.label.color = color
    item.label.fontFamily = getEchartsFontFamily()
    chartInstance.setOption(option)
  })
}

/** 饼图点击事件处理 */
export function useLabelClick (chartInstance: echarts.EChartsType, callback?: (params: any) => void) {
  chartInstance.on('click', 'series', (params: any) => {
    const dataItem = params.data
    if (dataItem && typeof dataItem === 'object' && typeof dataItem.click === 'function') {
      dataItem.click()
    } else if (callback) {
      callback(params)
    }
  })
}
